import React from "react";
import useFetchData from "../../repo/get";
import { useHistory } from "react-router-dom";
// components

import CardStats from "components/hooks/CardStats.js";

export default function HeaderStats() {
  const history = useHistory();
  const baseSelect = localStorage.getItem("baseSelected") || "";
  const cargoSelect = localStorage.getItem("cargo") || "";

   const { data: data_codigo } = useFetchData(`api/romaneios/count/codigos/${baseSelect}${cargoSelect === "ENTREGADOR" ? `?entregadorId=${localStorage.getItem("id")}` : ""}`);

   const { data: data_codigo_top } = useFetchData(`api/romaneios/count/${baseSelect}${cargoSelect === "ENTREGADOR" ? `?entregadorId=${localStorage.getItem("id")}` : ""}`);

   const handleRedirect = (id) => {
    history.push(`/admin/${id}`);
  };
  return (
    <>
      {/* Header */}
      <div className="relative bg-lightBlue-600 md:pt-32 pb-32 pt-12">
        <div className="px-4 md:px-10 mx-auto w-full">
          <div>
            {/* Card stats */}
            <div className="flex flex-wrap">
              <button onClick={() => handleRedirect("logistica/base")} className="w-full justify-between text-left lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="BASE"
                  statTitle={data_codigo_top?.aguardando ?? 0}
                  statArrow="up"
                  statPercent={data_codigo?.aguardando ?? 0}
                  statPercentColor="text-emerald-500"
                  statDescripiron="Pacotes em base"
                  statIconName="fa fa-home"
                  statIconColor="bg-emerald-500"
                />
              </button>
              <button onClick={() => handleRedirect("logistica/rua")} className="w-full justify-between text-left lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="Trânsito"
                  statTitle={data_codigo_top?.rua ?? 0}
                  statArrow="up"
                  statPercent={data_codigo?.rua ?? 0}
                  statPercentColor="text-emerald-500"
                  statDescripiron="Pacotes em transito"
                  statIconName="fa fa-truck"
                  statIconColor="bg-lightBlue-500"
                />
              </button>
              <button onClick={() => handleRedirect("logistica/recusados")} className="w-full justify-between text-left lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="RECUSADO"
                  statTitle={data_codigo_top?.recusado ?? 0}
                  statArrow="up"
                  statPercent={data_codigo?.recusado ?? 0}
                  statPercentColor="text-emerald-500"
                  statDescripiron="Pacotes com entregador"
                  statIconName="fa fa-thumbs-down"
                  statIconColor="bg-red-500"
                />
              </button>
              <button onClick={() => handleRedirect("administrativo/ocorrencia")} className="w-full justify-between text-left lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="Ocorrência"
                  statTitle={data_codigo_top?.ocorrencia ?? 0}
                  statArrow="up"
                  statPercent={data_codigo?.ocorrencia ?? 0}
                  statPercentColor="text-emerald-500"
                  statDescripiron="Pacotes em ocorrência"
                  statIconName="fa fa-life-ring"
                  statIconColor="bg-orange-500"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
